import { render, staticRenderFns } from "./InformacoesCircuitoComponent.vue?vue&type=template&id=408a4ac6"
import script from "./InformacoesCircuitoComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesCircuitoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports